import { render, staticRenderFns } from "./DisplayCommemorativeMedal.vue?vue&type=template&id=a2032e6a&scoped=true"
import script from "./DisplayCommemorativeMedal.vue?vue&type=script&lang=js"
export * from "./DisplayCommemorativeMedal.vue?vue&type=script&lang=js"
import style0 from "./DisplayCommemorativeMedal.vue?vue&type=style&index=0&id=a2032e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2032e6a",
  null
  
)

export default component.exports